import React from 'react';
import { IBootstrapTableColumnProps } from 'react-bootstrap-table-next';
import { BodyText, Button, DataGrid, NavigationItem } from 'ui-toolkit';
import { formatPhoneNumber } from '../../../../utilities/shared/formatPhoneNumber';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/pro-regular-svg-icons';
import { IClientContactData, IPresentationClientContactData } from '../../../../types/contacts/IClientContact';
import { getListOfPresentationContacts } from '../../../../types/contacts/IPresentationContactData';
import { IContactFunctionData } from '../../../../types/contacts/IContactFunctionData';

interface IClientContactsTableProps {
  data: IClientContactData[];
  loading: boolean;
  onEditContact: (contact: IClientContactData) => void;
  contactFunctions: IContactFunctionData[];
}

export const ClientOrderContactsTable: React.FC<IClientContactsTableProps> = ({
  data,
  loading,
  onEditContact,
  contactFunctions,
}) => {
  const tableData: IPresentationClientContactData[] = getListOfPresentationContacts(
    data,
    contactFunctions.filter((func) => func.isClient).map((func) => func.id)
  );

  const columns: IBootstrapTableColumnProps[] = [
    {
      text: 'Function',
      dataField: 'function',
      sort: true,
      formatter: (cell) => <>{contactFunctions.find((func) => func.id === cell)?.label}</>,
    },
    {
      text: 'Name',
      dataField: 'firstName',
      sort: true,
      formatter: (cell, row) => {
        const contact = row as IPresentationClientContactData;
        return <>{`${contact.firstName} ${contact.lastName}`}</>;
      },
    },
    {
      text: 'Email',
      dataField: 'email',
      sort: true,
      formatter: (cell) => <NavigationItem text={cell} isActive isInline href={`mailto:${cell}`} />,
    },
    {
      text: 'Phone',
      dataField: 'phoneNumber',
      sort: true,
      formatter: (cell) => <>{formatPhoneNumber(cell || '')}</>,
    },
    {
      text: 'Notes',
      dataField: 'notes',
      sort: false,
      formatter: (cell) => <BodyText style={{ whiteSpace: 'pre-line' }}>{cell}</BodyText>,
    },
    {
      text: 'Options',
      dataField: 'id',
      formatter: (cell, row) => (
        <Button intent={'ghost'} onClick={() => onEditContact(row as IClientContactData)}>
          <FontAwesomeIcon icon={faEdit} />
        </Button>
      ),
    },
  ];

  return <DataGrid columns={columns} keyField={'key'} data={tableData} loading={loading} />;
};
